import React from 'react';
import { IAlert } from './interface';
import { Row, Column } from "components/Layout/Grid";
import Text from 'components/Text';

import './styles.scss';

export const Alert: React.FC<IAlert> = (props) => {
  const {
    title,
    titleFontSize,
    description,
    descriptionFontSize,
    img,
    className,
    onClick
  } = props;

  return (
    <Column className={`mt-5 background-alert ${className}`} onClick={onClick}>
      <Row>
        {img && <img src={img} width={50} alt="img alert" className="mr-2" />}

        <Column>
          <Text className="color-blue-gray font-bold" size={titleFontSize || 12}>
            {title}
          </Text>
          <Text className="color-blue-gray" size={descriptionFontSize || 12}>
            {description}
          </Text>
        </Column>
      </Row>
    </Column>
  );
};